module.exports = __webpack_public_path__ + "static/img/Chris-Leong_2017-18.2b24cef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/leadership/Chris-Leong_2017-18.jpg
// module id = 8c8C
// module chunks = 0